/*
 * Carrossel das seções da home (layout "carrossel" do Homepage tags,
 * partials/components/section-carousel.hbs).
 *
 * A troca automática acontece quando termina a animação CSS que preenche o
 * segmento ativo. Assim, pausar a animação (mouse em cima, foco do teclado)
 * também pausa a troca, e quem pede menos movimento (sem animação) não tem
 * troca automática.
 */
(function () {
    document.querySelectorAll('[data-carrossel]').forEach(function (raiz) {
        var trilho = raiz.querySelector('.pp-carrossel-trilho');
        var slides = Array.prototype.slice.call(raiz.querySelectorAll('.pp-carrossel-slide'));
        var segmentos = Array.prototype.slice.call(raiz.querySelectorAll('.pp-carrossel-segmento'));
        var atual = 0;
        var espera;

        if (slides.length < 2) {
            raiz.classList.add('is-unico');
            return;
        }

        function marcar(i) {
            atual = i;
            slides.forEach(function (slide, n) {
                slide.setAttribute('aria-label', (n + 1) + ' de ' + slides.length);
                slide.toggleAttribute('inert', n !== i);
            });
            segmentos.forEach(function (segmento, n) {
                segmento.classList.remove('is-ativo');
                segmento.setAttribute('aria-current', n === i ? 'true' : 'false');
            });
            void raiz.offsetWidth; // reinicia a animação do segmento
            segmentos[i].classList.add('is-ativo');
        }

        function ir(i) {
            i = (i + slides.length) % slides.length;
            marcar(i);
            trilho.scrollTo({left: i * trilho.clientWidth, behavior: 'smooth'});
        }

        raiz.querySelector('.is-anterior').addEventListener('click', function () {
            ir(atual - 1);
        });
        raiz.querySelector('.is-proximo').addEventListener('click', function () {
            ir(atual + 1);
        });
        segmentos.forEach(function (segmento, n) {
            segmento.addEventListener('click', function () {
                ir(n);
            });
        });

        raiz.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') ir(atual - 1);
            if (e.key === 'ArrowRight') ir(atual + 1);
        });

        // fim do preenchimento do segmento ativo → próximo slide
        raiz.addEventListener('animationend', function (e) {
            if (e.animationName === 'pp-carrossel-progresso') ir(atual + 1);
        });

        // arrastar com o dedo: sincroniza quando a rolagem para
        trilho.addEventListener('scroll', function () {
            clearTimeout(espera);
            espera = setTimeout(function () {
                var i = Math.round(trilho.scrollLeft / trilho.clientWidth);
                if (i !== atual) marcar(i);
            }, 120);
        }, {passive: true});

        marcar(0);
    });
})();
